module.exports = __webpack_public_path__ + "static/media/serviceIndustry1.cbab216f.png";